const constants = {
  kb: 1024,
  mb: 1024 ** 2,
  gb: 1024 ** 3,
};

export default constants;
